import { render, staticRenderFns } from "./ReturnsView.vue?vue&type=template&id=8c07fde0"
import script from "./ReturnsView.vue?vue&type=script&lang=js"
export * from "./ReturnsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports